import { Avatar } from "@material-ui/core";
import { Rating } from "@material-ui/lab";
import Tippy from "@tippy.js/react";
import React from "react";
import { withRouter } from "react-router";
import {
  companyProfilePicImage,
  dateIconImage,
  deleteBinImage,
  infoIconImage,
  startRatingImage,
  timeIconImage,
  truckGreyIconImage,
} from "../../../assets";
import { invokeApi, s3baseUrl } from "../../../bl_libs/invokeApi";
function CompanyCard(props) {
  const {
    company,
    customer_budget,
    pushUrl,
    isLoading,
    setIsLoading,
    errMessage,
    setErrMessage,
    requestData,
    fetchCompanyList,
    discount,
  } = props;
  const { schedule_time, s_date } = requestData.request;
  const { bid, comapny_profile, truck_count, company_rating } = company;
  const { about_company, name, profile_picture } = comapny_profile;
  const { bid_amount, request_id, company_id } = bid;
  console.log(props, "props=>");

  const acceptBid = () => {
    let requestObj = {
      path: "/api/customer/accept_request",
      method: "PUT",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${request_id}`,
      company_id: `${company_id}`,
      final_amount: `${bid_amount}`,
    };
    requestObj["postData"] = postData;
    setIsLoading(true);

    invokeApi(requestObj).then((res) => {
      console.log(res);
      if (res.code === 200) {
        setErrMessage("");
        pushUrl("/dashboard/my-requests/" + request_id);
      } else {
        setErrMessage(res.message);
      }
      setIsLoading(false);
    });
  };

  const deleteBid = () => {
    let requestObj = {
      path: "/api/customer/delete_bid",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${request_id}`,
      company_id: `${company_id}`,
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      console.log(res, "DELETE BID RESPONSE");
      if (res.code === 200) {
        fetchCompanyList(request_id);
      } else {
        setErrMessage(res.message);
        setIsLoading(false);
      }
    });
  };

  const location = () => {
    props.history.push({
      pathname: "/dashboard/review-profile",
      state: company,
    });
    // props.history.push("/dashboard/review-profile");
  };

  return (
    <>
      <div className="rounded-box p-3 pb-10 mb-4">
        <div className="req-id-status-wrapper pb-2 pb-sm-3 ">
          <div className="row border-bottom">
            <div className="col-10 font-weight-bold">
              <div className="row">
                <div className="col-4 col-sm-2 col-md-2 col-lg-2 col-xl-1">
                  {profile_picture ? (
                    <img
                      style={{ width: "100%", borderRadius: "50%" }}
                      src={s3baseUrl + profile_picture}
                    ></img>
                  ) : (
                    <Avatar
                      style={{
                        width: 70,
                        height: 70,
                        fontSize: 22,
                        textAlign: "center",
                        paddingLeft: 5,
                      }}
                    >
                      {/* {name[0].toUpperCase()} */}
                    </Avatar>
                  )}
                </div>
                <div className="col-8 col-sm-10 col-md-10 col-lg-10 col-xl-11">
                  <div className="row">
                    <div className="col-12">
                      <span className="pointer-point" onClick={location}>
                        {name}
                      </span>

                      <Tippy
                        content={about_company ? about_company : ""}
                        animation="scale"
                        delay={[300, 0]}
                        arrow={false}
                        placement="bottom"
                        maxWidth={200}
                      >
                        <img
                          style={{ width: 20, height: 20 }}
                          className="pl-1 "
                          src={infoIconImage}
                        ></img>
                      </Tippy>
                    </div>
                    <div className="col-12">
                      <span className="small-grey-text mr-1">
                        {truck_count}
                      </span>
                      <img src={truckGreyIconImage}></img>
                      <span className="small-grey-text ml-2">
                        Rating {company_rating}
                      </span>
                      <Rating
                        className="align-bottom pl-md-2 pb-1"
                        value={company_rating}
                        precision={0.1}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-2 text-right">
              <img
                className="pointer-point"
                onClick={deleteBid}
                src={deleteBinImage}
              />
            </div>
          </div>
        </div>

        <div className="row no-gutters pl-3">
          <div className="col-12 col-sm-6 pb-2">
            <img className="pr-2" src={dateIconImage} />
            {/* {schedule_time.slice(0, 11)} */}
            {s_date}
          </div>
          <div className="col-12 col-sm-6 pb-2 req-info-text">
            <img src={timeIconImage} className="pr-2" />
            {schedule_time.slice(11, schedule_time.length)}
          </div>
        </div>
        <div className="">
          <div className="row pt-2 pb-2 ">
            <div className="col-8 col-md-4">
              <span className="grey-text-13">Company price:</span>
            </div>
            <div className="col-4 col-md-2">
              <span className="black-bold-15">${bid_amount}</span>
            </div>
            {/* dicount */}
            {parseInt(discount) > 0 && (
              <>
                <div className="col-8 col-md-4">
                  <span className="grey-text-13">Discount</span>
                </div>
                <div className="col-4 col-md-2">
                  <span className="black-bold-15">{discount} %</span>
                </div>

                <div className="col-8 col-md-4">
                  <span className="grey-text-13">Discounted price:</span>
                </div>
                <div className="col-4 col-md-2">
                  <span className="black-bold-15">
                    ${bid_amount * (1 - parseInt(discount) / 100)}
                  </span>
                </div>
              </>
            )}
            <div className="col-8 col-md-4">
              <span className="small-grey-text">Your price:</span>
            </div>
            <div className="col-4 col-md-2">
              <span className="small-grey-text">${customer_budget}</span>
            </div>
          </div>
        </div>
        <div className="row justify-content-center pt-3">
          <div className="col-12 col-sm-6 col-md-5 col-lg-4 text-center ">
            <button
              type="button"
              onClick={() => acceptBid()}
              className="custom-buton custom-buton-large w-100"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default withRouter(CompanyCard);
